module.exports = __webpack_public_path__ + "img/7.6.CODm.c7082f17.png";